import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProgressComponent} from './components/progress/progress.component';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {ReadableDatePipe} from './pipes/readable-date.pipe';
import {HashtagPipe, HashtagPipeV2} from './pipes/hashtag.pipe';
import {ImageUploaderComponent} from '../cms/files/components/image-uploader/image-uploader.component';
import {TreeNodeComponent} from './components/tree-node/tree-node.component';
import {RouterLink} from "@angular/router";
import {PaginationComponent} from './components/pagination/pagination.component';
import {BasicFilterComponent} from './components/basic-filter/basic-filter.component';
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {UserFilterComponent} from "./components/user-filter/user-filter.component";
import {DeleteComponent} from "./components/delete/components/delete/delete.component";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ImageUploaderComponentV2} from "../cms/files/components/image-uploader-v2/image-uploader-v2.component";
import {EditorComponent} from './components/editor/editor.component';
import {CKEditorModule} from "@ckeditor/ckeditor5-angular";
import {TranslatePipe} from "./translation.utility";
import {ImageHoverPopupDirective} from "./directives/img-hover-popup.directive";

@NgModule({
  providers: [
    {provide: MAT_DIALOG_DATA, useValue: {}},
    {provide: MatDialogRef, useValue: {}}
  ],
  declarations: [
    ProgressComponent,
    ReadableDatePipe,
    HashtagPipe,
    ImageUploaderComponent,
    ImageUploaderComponentV2,
    TreeNodeComponent,
    PaginationComponent,
    BasicFilterComponent,
    UserFilterComponent,
    DeleteComponent,
    EditorComponent,
    TranslatePipe,
    HashtagPipeV2,
    ImageHoverPopupDirective
  ],
  exports: [
    ProgressComponent,
    ReadableDatePipe,
    HashtagPipe,
    ImageUploaderComponent,
    ImageUploaderComponentV2,
    TreeNodeComponent,
    PaginationComponent,
    UserFilterComponent,
    BasicFilterComponent,
    DeleteComponent,
    EditorComponent,
    TranslatePipe,
    HashtagPipeV2,
    ImageHoverPopupDirective
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    RouterLink,
    BsDatepickerModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    CKEditorModule
  ]
})
export class UtilityModule {
}
